import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { BiEdit } from "react-icons/bi";
import { headApi } from "utils/headApi";
import { localApi } from "utils/imgApi";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleCheck = makeStyles(styleCheck);
const useStyleSweet = makeStyles(styleSweet);

export default function UpdateBox(props) {
  const [items, setItems] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
  const [boxDesc, setBoxDesc] = React.useState("");
  const [packingCharge, setPackingCharge] = React.useState("");
  const [box, setBox] = React.useState("");
  const [hsncode, setHsncode] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [ligst, setLigst] = React.useState("");
  const [getId, setGetId] = React.useState("");
  const [boxDescErr, setBoxDescErr] = React.useState("");
  const [packChargeErr, setPackchargeErr] = React.useState("");
  const [boxErr, setBoxErr] = React.useState("");
  const [hsncodeErr, setHsncodeErr] = React.useState("");
  const [priceErr, setPriceErr] = React.useState("");
  const [ligstErr, setLigstErr] = React.useState("");
  const [active, setActive] = React.useState(false);
  const [brandName, setBrandName] = React.useState("");
  const [brandNameErr, setBrandNameErr] = React.useState("");

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classCheck = useStyleCheck();
  const classSweet = useStyleSweet();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api = localApi + `/box/list/byAdminId/${userObj && userObj.id}`;
    const result = await fetch(api);
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleSimple = (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.id == value);
    // console.log(item);
    setSimpleSelect(value);
    setSimpleSelectErr("");
    setBoxDesc(item.boxDesc);
    setBrandName(item.brandName);
    setPackingCharge(item.pkgCharge);
    setBox(item.box);
    setHsncode(item.hsnCode);
    setPrice(item.price);
    setLigst(item.tax_percentage);
    setActive(item.active);
    setGetId(item.id);
  };

  const handleBoxDesc = (e) => {
    const { value } = e.target;
    setBoxDesc(value);
    setBoxDescErr("");
  };

  const SubmitUpdateBox = () => {
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Box Description");
    }
    if (boxDesc === "" || !boxDesc) {
      errorCount++;
      setBoxDescErr("Description Name is Required");
    }
    if (brandName === "" || !brandName) {
      errorCount++;
      setBrandNameErr("Brand Name is Required");
    }
    if (packingCharge === "" || !packingCharge) {
      errorCount++;
      setPackchargeErr("Packing Labour is Required");
    }
    if (box === "" || !box) {
      errorCount++;
      setBoxErr("Box is Required");
    }
    if (hsncode === "" || !hsncode) {
      errorCount++;
      setHsncodeErr("HSN Code is Required");
    }
    if (price === "" || !price) {
      errorCount++;
      setPriceErr("Price is Required");
    }
    if (ligst === "" || !ligst) {
      errorCount++;
      setLigstErr("GST is Required");
    }
    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          adminId: userObj.id,
          boxDesc: boxDesc,
          brandName: brandName,
          pkgCharge: packingCharge,
          box: box,
          hsnCode: hsncode,
          price: price,
          tax_percentage: ligst,
        }),
      };

      fetch(localApi + `/box/update/boxById/${getId}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Updated Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <BiEdit />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Update Box</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >Updated Box</SweetAlert>
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Box Description...
                    </InputLabel>

                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Box Description...
                      </MenuItem>
                      {items &&
                        items.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item.boxDesc + " - " + item.brandName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  <span style={{ color: "red" }}>{simpleSelectErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Box Description..."
                    id="boxDesc"
                    inputProps={{
                      placeholder: "Box Description...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="boxDesc"
                    value={boxDesc}
                    onChange={handleBoxDesc}
                    // onChange={(e) => {
                    //   setBoxDesc(e.target.value);
                    //   setBoxDescErr("");
                    // }}
                    // required={true}
                  />
                  <span style={{ color: "red" }}>{boxDescErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Brand Name..."
                    id="brandName"
                    inputProps={{
                      placeholder: "Brand Name...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="brandName"
                    value={brandName}
                    onChange={(e) => {
                      setBrandName(e.target.value);
                      setBrandNameErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{brandNameErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Box Packing Labour..."
                    id="packingCharge"
                    inputProps={{
                      placeholder: "Box Packing Labour...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="packingCharge"
                    value={packingCharge}
                    onChange={(e) => {
                      setPackingCharge(e.target.value);
                      setPackchargeErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{packChargeErr}</span>
                </GridItem>
                <GridItem xs={12} sm={6} md={6}>
                  <CustomInput
                    labelText="Box 6/12/18..."
                    id="box"
                    inputProps={{
                      placeholder: "Box 6/12/18...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="box"
                    value={box}
                    onChange={(e) => {
                      setBox(e.target.value);
                      setBoxErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{boxErr}</span>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText="HSN Code..."
                    id="hsncode"
                    inputProps={{
                      placeholder: "HSN Code...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="hsncode"
                    value={hsncode}
                    onChange={(e) => {
                      setHsncode(e.target.value);
                      setHsncodeErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{hsncodeErr}</span>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText="Price..."
                    id="price"
                    inputProps={{
                      placeholder: "Price...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="price"
                    value={price}
                    onChange={(e) => {
                      setPrice(e.target.value);
                      setPriceErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{priceErr}</span>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <CustomInput
                    labelText="GST @18%..."
                    id="ligst"
                    inputProps={{
                      placeholder: "GST @18%...",
                    }}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="ligst"
                    value={ligst}
                    onChange={(e) => {
                      setLigst(e.target.value);
                      setLigstErr("");
                    }}
                    required={true}
                  />
                  <span style={{ color: "red" }}>{ligstErr}</span>
                </GridItem>
              </GridContainer>
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Update</Button>
              ) : (
                <Button
                  color="rose"
                  onClick={SubmitUpdateBox}
                  className={classes.updateProfileButton}
                >
                  Update
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
